import { Form, Modal, Button, Table } from 'react-bootstrap'
import { useEffect, useState } from 'react'

import callAPI from '../../../../../helpers/callAPI'
import Loading from '../../../../../templates/UI/Loading/Loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactTooltip from 'react-tooltip'

const LPModal = ({ isOpen, setIsOpen, landingPages, refetch, selectedLPId, selectedLP, showSystemMessage, campaignId }) => {

    const [data, setData] = useState({ landingPage: {}, platform: {} })
    const [dataLoaded, setDataLoaded] = useState(false)
    const [safesearchOverride, setSafesearchOverride] = useState(false)
    const [landingPageOverride, setLandingPageOverride] = useState('')
    const [safesearchEnableParam, setSafesearchEnableParam] = useState('')
    const [safesearchEnableValue, setSafesearchEnableValue] = useState('')
    const [safesearchUrlParam, setSafesearchUrlParam] = useState('')
    const [safesearchUrlValue, setSafesearchUrlValue] = useState('')
    const [notifyAffiliates, setNotifyAffiliates] = useState(false)

    const [defaultLandingPage, setDefaultLandingPage] = useState(false)
    const [disableDefaultOption, setDisableDefaultOption] = useState(false)
    const [disableLpSafesearch, setDisableLPSafesearch] = useState(false)
    const [safesearchFinalUrl, setSafesearchFinalUrl] = useState('')
    const [deeplinkEnabled, setDeeplinkEnabled] = useState('')

    let isCreate = selectedLPId === 0 ? true : false

    useEffect(() => {
        if (isCreate) {
            setDataLoaded(true)
            return
        }
        getLandingPageInfo()
    }, [selectedLPId])

    const getLandingPageInfo = () => {
        setDataLoaded(false)
        let url = `campaign/${campaignId}/landingPages/${selectedLPId}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setData(result.data)

                    setSafesearchOverride(result.data.platform.safesearch_certified === 'Y' ? true : false)
                    setLandingPageOverride(result.data.landingPage.lp_allows_safesearch)

                    setSafesearchEnableParam(result.data.platform.safesearch_enable_param)
                    setSafesearchEnableValue(result.data.platform.safesearch_enable_value)
                    setSafesearchUrlParam(result.data.platform.safesearch_url_param)
                    setSafesearchUrlValue(result.data.landingPage.lp_safesearch_url_value)
                    setDeeplinkEnabled(result.data.landingPage.lp_allows_deeplink)

                    setDefaultLandingPage(result.data.landingPage.lp_default_flag === 'Y' ? true : false)

                    if ((landingPages.length === 0 || result.data.landingPage.lp_default_flag === 'Y' || result.data.landingPage.lp_status !== 'A')) {
                        setDisableDefaultOption(true)
                    }

                    if (result.data.landingPage.lp_allows_safesearch === 'Y' || result.data.landingPage.lp_allows_safesearch === 'N') {
                        setDisableLPSafesearch(true)
                    } else {
                        setDisableLPSafesearch(false)
                    }

                    if (result.data.platform.safesearch_certified === 'N' || (result.data.landingPage.lp_allows_safesearch === 'Y' || result.data.landingPage.lp_allows_safesearch === 'N')) {
                        setSafesearchFinalUrl('')
                    } else {
                        setSafesearchFinalUrl(result.data.landingPage.lp_safesearch_url_value)
                    }

                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                }
                setDataLoaded(true)
            })
            .catch((error) => {
                showSystemMessage('error', `An error occurred while fetching landing page: ${error.message}`)
            })
    }

    const getSafeSearchLPPreview = (landingUrl) => {

        let finalLandingPage = landingUrl

        if (finalLandingPage.substring(0, 7) !== 'http://' && finalLandingPage.substring(0, 8) !== 'https://') {
            return finalLandingPage
        }

        // Check if there are pre-existing params for safesearch already in the landing url. Those may need to be there for regular, non-safesearch links.
        // But for safesearch, we need to only rely on the one in the LP field.

        // Strip hashtags first as it messes up the new URL functionality                
        finalLandingPage = finalLandingPage.replace(/#/g, "%23")
        finalLandingPage = new URL(finalLandingPage);

        let existingEnableParam = finalLandingPage.searchParams.has(safesearchEnableParam)
        let existingUrlParam = finalLandingPage.searchParams.has(safesearchUrlParam)

        if (existingEnableParam) {
            // We want to remove it from the finalUrl and rely on the value from the LP settings instead
            finalLandingPage.searchParams.delete(safesearchEnableParam)
        }

        if (existingUrlParam) {
            // We want to remove it from the finalUrl and rely on the value from the LP settings instead
            finalLandingPage.searchParams.delete(safesearchUrlParam)
        }

        // Bring back the hashtags
        finalLandingPage = finalLandingPage.href.replace(/%23/g, "#")
        finalLandingPage = finalLandingPage.toString()

        let paramsToAppend = []

        if (landingPageOverride !== 'Y' && landingPageOverride !== 'N') {
            if (safesearchEnableParam && safesearchEnableValue) {
                paramsToAppend.push(`${safesearchEnableParam}=${safesearchEnableValue}`)
            }

            if (safesearchUrlParam && safesearchUrlValue) {
                // Encode everything EXCEPT hashtags... as it could be macros that we actually need on the affiliate side...
                paramsToAppend.push(`${safesearchUrlParam}=${encodeURIComponent(safesearchUrlValue).replace(/%23/g, "#")}`);
            }
        }

        if (paramsToAppend.length > 0) {
            // check if the url already has query params
            if (finalLandingPage.includes('?')) {
                finalLandingPage += `&${paramsToAppend.join('&')}`;
            } else {
                finalLandingPage += `?${paramsToAppend.join('&')}`;
            }
        }

        return finalLandingPage

    }

    const validate = (e) => {

        e.target.name.setCustomValidity('')
        e.target.landing_url.setCustomValidity('')

        if (isCreate) {
            let isDuplicate = landingPages.some((page) => page.lp_name.trim() === e.target.name.value.trim())

            if (isDuplicate) {
                e.target.name.setCustomValidity('Landing Page Name already exists')
                return false
            }

        } else {
            let isDuplicate = landingPages.some((page) => page.lp_record_id !== selectedLPId && page.lp_name.trim() === e.target.name.value.trim())

            if (isDuplicate) {
                e.target.name.setCustomValidity('Landing Page Name already exists')
                return false
            }
        }

        let landingUrl = e.target.landing_url.value

        if (landingUrl.substring(0, 7) !== 'http://' && landingUrl.substring(0, 8) !== 'https://') {
            e.target.landing_url.setCustomValidity('Landing URL is improperly formatted')
            return false
        }

        return true
    }

    const createLandingPage = async (e) => {
        e.preventDefault()

        let validated = validate(e)

        if (!validated) {
            e.target.reportValidity()
            return false
        }

        const body = {
            lp_default_flag: e.target.default_landing_flag.checked ? 'Y' : 'N',
            lp_landing_url: e.target.landing_url.value,
            lp_name: e.target.name.value,
            lp_record_id: selectedLP.lp_record_id,
            lp_status: e.target.lp_status.value,
            lp_allows_safesearch: e.target.allows_safesearch.value,
            lp_safesearch_url_value: e.target.safesearch_url_value ? e.target.safesearch_url_value.value : '',
            allows_deeplink: e.target.deeplink_enabled.value,
            deeplink_instructions: deeplinkEnabled === 'Y' ? (e.target.deeplink_instructions ? e.target.deeplink_instructions.value : '') : ''
        }

        // Create a backend function for getsafesearchLink where you don't feed data but it gets it's own data through query from withing the function to reduce the weight on the places it's being called from.

        const response = await callAPI(`campaign/${campaignId}/landingPages`, 'POST', body)

        if (response.success) {
            refetch()
            setIsOpen(false)
            showSystemMessage('success', 'Landing Page Created')
        } else {
            showSystemMessage('error', response.errors.message)

        }
    }

    const updateLandingPage = async (e) => {
        e.preventDefault()

        let validated = validate(e)

        if (!validated) {
            e.target.reportValidity()
            return false
        }

        const body = {
            lp_default_flag: e.target.default_landing_flag.checked ? 'Y' : 'N',
            lp_landing_url: e.target.landing_url.value,
            lp_name: e.target.name.value,
            lp_record_id: selectedLPId,
            lp_status: e.target.lp_status.value,
            lp_allows_safesearch: e.target.allows_safesearch.value,
            lp_safesearch_url_value: e.target.safesearch_url_value ? e.target.safesearch_url_value.value : '',
            notify_affiliates: notifyAffiliates,
            allows_deeplink: e.target.deeplink_enabled.value,
            deeplink_instructions: deeplinkEnabled === 'Y' ? (e.target.deeplink_instructions ? e.target.deeplink_instructions.value : '') : ''
        }

        const response = await callAPI(`campaign/${campaignId}/landingPages/${selectedLPId}`, 'PUT', body)

        if (response.success) {
            refetch()
            setIsOpen(false)
            showSystemMessage('success', 'Landing Page Updated')
        } else {
            showSystemMessage('error', response.errors.message)
        }
    }

    const inputChangeHandler = (e) => {

        if (e.target.name === 'allows_safesearch') {
            setLandingPageOverride(e.target.value)
        }

        if (e.target.name === 'default_landing_flag') {
            setDefaultLandingPage(!defaultLandingPage)
        }

        if (e.target.name === 'allows_safesearch') {
            if (e.target.value === 'Y' || e.target.value === 'N') {
                setDisableLPSafesearch(true)
                setSafesearchFinalUrl('')
            } else {
                setDisableLPSafesearch(false)
                setSafesearchFinalUrl(data.landingPage.lp_safesearch_url_value)
            }
        }

        if (e.target.name === 'deeplink_enabled') {
            setDeeplinkEnabled(e.target.value)
        }

        e.target.setCustomValidity('')
    }

    const activeLandingPages = landingPages.filter(lp => lp.lp_status === 'A')

    return (
        <Modal
            show={isOpen}
            onHide={() => {
                setIsOpen(false)
            }}
        >
            <form onSubmit={isCreate ? createLandingPage : updateLandingPage}>
                <Modal.Header closeButton>
                    <Modal.Title>{isCreate ? 'Add Landing Page' : 'Edit Landing Page'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dataLoaded ? <table className='table table-borderless table-card'>
                        <tbody>
                            <tr>
                                <td>Landing Page Name</td>
                                <td>
                                    {data.landingPage.lp_name}
                                    <Form.Control
                                        type={isCreate ? "text" : "hidden"}
                                        name="name"
                                        placeholder="Enter Landing Page Name"
                                        defaultValue={data.landingPage.lp_name}
                                        onChange={inputChangeHandler}
                                        required
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Landing Page URL</td>
                                <td>
                                    <textarea className="form-control" onChange={inputChangeHandler} required name="landing_url" rows={6} defaultValue={data.landingPage.lp_landing_url} />
                                </td>
                            </tr>
                            {
                                data.platform.safesearch_certified === 'Y' && (
                                    <tr>
                                        <td>Safesearch LP</td>
                                        <td>
                                            <textarea disabled className="form-control" rows={6}>
                                                {getSafeSearchLPPreview(data.landingPage.lp_landing_url)}
                                            </textarea>
                                            <span className="text-secondary">If the landing page URL already has some of the safesearch parameters present, they will be replaced by the one set below when affiliates pull safesearch links.</span>
                                        </td>
                                    </tr>
                                )
                            }
                            {data.campaign_receives_safesearch_traffic && <tr>
                                <td>&nbsp;</td>
                                <td>
                                    <div className='alert alert-danger'>
                                        SafeSearch Traffic Detected - modifying the landing page may cause affiliate links to stop working.
                                        If editing the landing page, you can use the below setting to automatically notify affiliates running traffic to this campaign to pull new links.
                                    </div>
                                    {!isCreate && (
                                        <div className="d-flex align-items-center alert alert-warning">
                                            <span className="font-weight-bold">Notify Affiliates to Pull New Links</span>
                                            <span className="ml-2"><input type="checkbox" name="notify_affiliates" onChange={() => setNotifyAffiliates(!notifyAffiliates)} checked={notifyAffiliates} /></span>
                                        </div>
                                    )
                                    }
                                </td>
                            </tr>}
                            {/* <tr>
                                <td>Landing Page URL (Pulled As)</td>
                                <td>
                                    <textarea className="form-control" onChange={inputChangeHandler} name="landing_url_preview" rows={6} disabled value={landingPageUrlPreview} />
                                </td>
                            </tr> */}
                            <tr>
                                <td>Default Landing Page</td>
                                <td><Form.Check
                                    type="checkbox"
                                    name="default_landing_flag"
                                    checked={landingPages.length === 0 ? true : defaultLandingPage}
                                    onChange={inputChangeHandler}
                                    disabled={disableDefaultOption}
                                />
                                </td>
                            </tr>
                            <tr>
                                <td>Landing Page Status</td>
                                {landingPages.length === 0 || (activeLandingPages.length <= 1 && data.landingPage.lp_status === 'A') || data.landingPage.lp_default_flag === 'Y' ? <td><span>Active</span>
                                    <input type="hidden" name="lp_status" value="A" />
                                </td> :
                                    <td><Form.Control
                                        as="select"
                                        name="lp_status"
                                        defaultValue={data.landingPage.lp_status}
                                        onChange={inputChangeHandler}
                                        required>
                                        <option value="A">Active</option>
                                        <option value="T">Testing</option>
                                        <option value="C">Cancelled</option>
                                    </Form.Control></td>}
                            </tr>

                            <tr className='border-top'>
                                <td>Safesearch Override</td>
                                <td>
                                    <span className='d-flex align-items-center'>
                                        <ReactTooltip />
                                        <Form.Control as="select" name="allows_safesearch" defaultValue={data.landingPage.lp_allows_safesearch || ''} onChange={inputChangeHandler} className='w-50'>
                                            <option value=""></option>
                                            <option value="Y">Enable</option>
                                            <option value="N">Disable</option>
                                        </Form.Control>
                                        <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={"This setting will completely override all other safesearch settings. It should only be used in cases where this landing page should behave differently than the default."} />
                                    </span>
                                </td>
                            </tr>

                            {
                                data.platform.safesearch_certified === 'Y' &&
                                <><tr>
                                    <td>Final URL</td>
                                    <td>
                                        <Form.Control type="text" name="safesearch_url_value" value={safesearchFinalUrl} onChange={(e) => setSafesearchFinalUrl(e.target.value)} required={safesearchOverride && !landingPageOverride?.trim()} disabled={disableLpSafesearch} />
                                        <span className="text-secondary">#S1#-#S5# macros can be used here to allow affiliate deeplinking.</span>
                                    </td>
                                </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>
                                            <div className='alert alert-info'>
                                                <strong>Search Certified Platform: </strong> this campaign's platform is Google Search Certified, so the final destination URL must be provided.
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            }
                            <tr>
                                <td>Deeplink Enabled</td>
                                <td>
                                    <span className='d-flex align-items-center'>
                                        <Form.Control as="select" name="deeplink_enabled" defaultValue={data.landingPage.lp_allows_deeplink} onChange={inputChangeHandler} className='w-50'>
                                            <option value=""></option>
                                            <option value="Y">Enable</option>
                                            <option value="N">Disable</option>
                                        </Form.Control>
                                    </span>
                                </td>
                            </tr>
                            {
                                deeplinkEnabled === 'Y' &&
                                <tr>
                                    <td>Deeplink Instructions</td>
                                    <td>
                                        <Form.Control as="textarea" name="deeplink_instructions" defaultValue={data.landingPage.lp_deeplink_instructions} onChange={inputChangeHandler} required={deeplinkEnabled === 'Y'} />
                                        {/* <span className="text-secondary">#S1#-#S5# macros can be used here to allow affiliate deeplinking.</span> */}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table> : <Loading />}
                    <h3 className="mt-4">Available Macros:</h3>
                    <Table striped bordered hover size="sm">
                        <tbody>
                            <tr align="left" width="100%">
                                <td>Click ID</td>
                                <td>#ACID#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>Affiliate ID</td>
                                <td>#MBID#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>IP Address</td>
                                <td>#IP#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>Referring URL</td>
                                <td>#REFURL#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>Affiliate Campaign API Token</td>
                                <td>#ACTOKEN#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>SUB-ID 1</td>
                                <td>#S1#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>SUB-ID 2</td>
                                <td>#S2#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>SUB-ID 3</td>
                                <td>#S3#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>SUB-ID 4</td>
                                <td>#S4#</td>
                            </tr>
                            <tr align="left" width="100%">
                                <td>SUB-ID 5</td>
                                <td>#S5#</td>
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    {isCreate ? (
                        <Button type="submit" variant="primary" size="sm">
                            Create
                        </Button>
                    ) : (
                        <Button type="submit" variant="primary" size="sm">
                            Update
                        </Button>
                    )}
                </Modal.Footer>
            </form>
        </Modal>
    )
}

export default LPModal

